import Swal from 'sweetalert2';

export function showErrorToast(message) {
	return Swal.fire({
		toast: true,
		position: "bottom-end",
		background: '#ff5555',
		color: '#fff',
		iconColor: '#fff',
		showConfirmButton: false,
		timer: 10000,
		timerProgressBar: true,
		didOpen: (toast) => {
			toast.onmouseenter = Swal.stopTimer;
			toast.onmouseleave = Swal.resumeTimer;
		},
		icon: 'error',
		title: message,
	});
}

export function showSuccessToast(message) {
	return Swal.fire({
		toast: true,
		position: "bottom-end",
		background: '#2e9f23',
		color: '#fff',
		iconColor: '#fff',
		showConfirmButton: false,
		timer: 7000,
		timerProgressBar: true,
		didOpen: (toast) => {
			toast.onmouseenter = Swal.stopTimer;
			toast.onmouseleave = Swal.resumeTimer;
		},
		icon: 'success',
		title: message,
	});
}

export async function gqlErrorToast (gqlError, t) {
	const handleErrors = async (errors) => {
		for (const error of errors) {
			let message = error.extensions?.exception?.constraint ?? error.extensions?.response?.message ?? error.message;
			if (Array.isArray(message) && message.length > 0) message = message[0];
			await translateGraphQLErrorAndToast(message, t);
		}
	}
	
	if (gqlError) {
		if (gqlError.networkError) {
			if (gqlError.networkError.result) await handleErrors(gqlError.networkError.result.errors);
			else await handleErrors([gqlError.networkError]);
		} else if (gqlError.graphQLErrors) {
			await handleErrors(gqlError.graphQLErrors);
		} else {
			await translateGraphQLErrorAndToast(gqlError.message, t);
		}
	}
}

async function translateGraphQLErrorAndToast(message, t) {
	if (message.startsWith('VALIDATOR|')) {
		const validateSplit = message.split('|');
		const key = t.has(`validators.keys.${validateSplit[2]}`) ? t(`validators.keys.${validateSplit[2]}`) : validateSplit[2];
		const value = t.has(`validators.keys.${validateSplit[3]}`) ? t(`validators.keys.${validateSplit[3]}`) : validateSplit[3];
		await showErrorToast(t(`validators.${validateSplit[1]}`, { key, value }));
		return;
	}
	if (message.startsWith('NOT_FOUND|')) {
		const validateSplit = message.split('|');
		const key = t.has(`notFound.keys.${validateSplit[1]}`) ? t(`notFound.keys.${validateSplit[1]}`) : validateSplit[1];
		await showErrorToast(t(`notFound.message`, { key }));
		return;
	}
	await showErrorToast(t.has(message) ? t(message) : message);
}

export function getGqlErrorToast (errors, t) {
	if (Array.isArray(errors)) {
		const list = [];
		for (let i = 0; i < errors.length; i++) {
			list.push(getTranslateGraphQLError(errors[i], t));
		}
		return list;
	}
	return getTranslateGraphQLError(errors, t);
}

function getTranslateGraphQLError(message, t) {
	if (message?.startsWith('VALIDATOR|')) {
		const validateSplit = message.split('|');
		const key = t.has(`validators.keys.${validateSplit[2]}`) ? t(`validators.keys.${validateSplit[2]}`) : validateSplit[2];
		const value = t.has(`validators.keys.${validateSplit[3]}`) ? t(`validators.keys.${validateSplit[3]}`) : validateSplit[3];
		return t(`validators.${validateSplit[1]}`, { key, value });
	}
	if (message?.startsWith('NOT_FOUND|')) {
		const validateSplit = message.split('|');
		const key = t.has(`notFound.keys.${validateSplit[1]}`) ? t(`notFound.keys.${validateSplit[1]}`) : validateSplit[1];
		return t(`notFound.message`, { key });
	}
	return t.has(message) ? t(message) : message;
}
